import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'outlined' | 'outlined-brand' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: 'md' | 'lg';
  icon?: ReactNode;
}

export function Button({
  variant = 'outlined',
  size = 'md',
  icon,
  children,
  className = '',
  type = 'button',
  ...props
}: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, size === 'lg' ? 'btn--lg' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...props}>
      {icon}
      {children}
    </button>
  );
}

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  brand?: boolean;
  children: ReactNode;
}

export function IconButton({ label, brand = false, children, className = '', ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={`icon-button ${brand ? 'icon-button--brand' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
